module.exports = __webpack_public_path__ + "static/media/animated_ashutosh.0732e7c7.jpg";